module.exports = __webpack_public_path__ + "static/espa-banner-b9bd7e95790cdda0e37c74ffb4ac3151.jpg";